<template>
    <aside class="menu app-sidebar animated" :class="{ slideInLeft: show, slideOutLeft: !show }">
        <ul class="menu-list">
            <li class="brand text-center">
                <img class="logo" src="static/img/logo_small.png" alt="LeadScorz" title="LeadScorz"><br>
                <span class="brandname">LeadScorz</span>
            </li>
            <template v-if="accountType == 'vendor'">
                <li>
                    <router-link to="/book-appointment">
                        <span class="icon is-small"><i class="fa fa-calendar-check-o" aria-hidden="true"></i></span>
                        Book Appointment
                    </router-link>
                </li>
                <li v-if="isAdmin">
                    <router-link to="/">
                        <span class="icon is-small"><i class="fa fa-pie-chart" aria-hidden="true"></i></span>
                        Stats
                    </router-link>
                </li>
                <li v-if="isAdmin">
                    <a :aria-expanded="leadsMenu.expanded" @click="leadsMenu.expanded = !leadsMenu.expanded">
                        <span class="icon is-small"><i class="fa fa-line-chart" aria-hidden="true"></i></span>
                        Leads
                        <span class="icon is-small is-angle">
                            <i class="fa fa-angle-down"></i>
                        </span>
                    </a>
                    <transition name="fade">
                        <div v-show="leadsMenu.expanded">
                            <ul v-show="customersList.length" class="sub-menu">
                                <li class="menu-item" v-for="(item, index) in customersList">
                                    <router-link :to="generatePath('leads', item)" exact>
                                        <i class="fa fa-angle-right"></i> {{ item.name }}
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </transition>
                </li>
            </template>
            <template v-if="accountType == 'customer'">
                <li>
                    <router-link to="/">
                        <span class="icon is-small"><i class="fa fa-home"></i></span> Home
                    </router-link>
                </li>
                 <li>
                    <a :aria-expanded="leadsMenu.expanded" @click="leadsMenu.expanded = !leadsMenu.expanded">
                        <span class="icon is-small"><i class="fa fa-bar-chart" aria-hidden="true"></i></span>
                        Leads
                        <span class="icon is-small is-angle">
                            <i class="fa fa-angle-down"></i>
                        </span>
                    </a>
                    <transition name="fade">
                        <div v-show="leadsMenu.expanded">
                            <ul v-show="dashboardList.length" class="sub-menu">
                                <li class="menu-item" v-for="(item, index) in dashboardList">
                                    <router-link :to="generatePath('dashboards', item)" exact>
                                        <i class="fa fa-angle-right"></i> {{ item.name }}
                                    </router-link>
                                </li>
                            </ul>
                            <div class="sidebar-buttons">
                                <button class="btn btn-default btn-block" v-on:click="$emit('showDashboardModal')">
                                    <i class="fa fa-plus-square-o" aria-hidden="true"></i> New
                                </button>
                            </div>
                        </div>
                    </transition>
                </li>

                <li>
                    <a :aria-expanded="analyticsMenu.expanded" @click="analyticsMenu.expanded = !analyticsMenu.expanded">
                        <span class="icon is-small"><i class="fa fa-flask" aria-hidden="true"></i></span>
                        Analytics
                        <span class="icon is-small is-angle">
                            <i class="fa fa-angle-down"></i>
                        </span>
                    </a>
                    <transition name="fade">
                        <div v-show="analyticsMenu.expanded">
                            <ul class="sub-menu">
                                <li>
                                    <router-link to="/model-stats">
                                        <span class="icon is-small"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Models
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="/agents-stats">
                                        <span class="icon is-small"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Agents
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="/agents-slots">
                                        <span class="icon is-small"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Slots
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </transition>
                </li>

                <li v-if="epicEnabled">
                    <a :aria-expanded="epicMenu.expanded" @click="epicMenu.expanded = !epicMenu.expanded">
                        <span class="icon is-small"><i class="fa fa-database" aria-hidden="true"></i></span>
                        EPIC
                        <span class="icon is-small is-angle">
                            <i class="fa fa-angle-down"></i>
                        </span>
                    </a>
                    <transition name="fade">
                        <div v-show="epicMenu.expanded">
                            <ul class="sub-menu">
                                <li>
                                    <router-link to="/epic/clients">
                                        <span class="icon is-small"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Clients
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="/epic/policies">
                                        <span class="icon is-small"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Policies
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </transition>
                </li>
            </template>
            <li v-if="accountType != 'customer' && !isSalesAgent">
              <a :aria-expanded="campaignsMenu.expanded" @click="campaignsMenu.expanded = !campaignsMenu.expanded">
                <span class="icon is-small"><i class="fa fa-exchange" aria-hidden="true"></i></span>
                Campaigns
                <span class="icon is-small is-angle">
                  <i class="fa fa-angle-down"></i>
                </span>
              </a>
              <transition name="fade">
                <div v-show="campaignsMenu.expanded">
                  <ul class="sub-menu">
                    <li>
                      <router-link to="/campaigns">
                        <span class="icon is-small"><i class="fa fa-cog" aria-hidden="true"></i> Active Campaigns</span>
                      </router-link>
                    </li>
                    <li v-if="showPostingInstructions">
                      <router-link to="/campaigns-docs">
                        <span class="icon is-small"><i class="fa fa-book" aria-hidden="true"></i> Posting Instructions</span>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </transition>
            </li>
        </ul>
        <footer class="footer">
            <div class="container-fluid">
              <div class="row">
                    <div class="col-xs-12 copyright">
                        <small><i class="fa fa-copyright" aria-hidden="true"></i> LeadScorz {{ new Date().getFullYear() }}</small>
                    </div>
                </div>
            </div>
        </footer>
    </aside>
</template>

<script>
  export default {
    name: 'sidebar',
    props: {
      show: Boolean,
     },
    data () {
      return {
        isAdmin: false,
        accountType: null,
        userRole: null,
	      dashboardList: [],
        customersList: [],
	      leadsMenu: {
	        expanded: false
        },
        analyticsMenu: {
          expanded: false
        },
	      dashboardsMenu: {
	        expanded: false
	      },
        leadsMenu: {
          expanded: false
        },
        epicMenu: {
          expanded: false
        },
        campaignsMenu: {
          expanded: false
        },
	      search: null,
        epicEnabled: false
      }
    },
    created() {
      var userProxy = this.$store.state.user;
      this.accountType = userProxy.current_account.account_type;
      this.userRole = userProxy.role;
      this.isAdmin = userProxy.role == 'admin' || userProxy.role == 'superuser'
        this.epicEnabled = userProxy.current_account.epic_integration;

      if (this.$store.getters.accountIsCustomer) {
        this.fetchDashboards();
        BUS.$on('refreshDashboardsList', this.fetchDashboards);
      }
      else {
        this.fetchCustomers();
      }
    },
    mounted () {
      let route = this.$route
      if (route.name) {
             this.isReady = true
      }
    },
    computed: {
      isSalesAgent() {
        return this.$store.getters.userIsSalesAgent;
      },
      showPostingInstructions() {
        if ('sales_representative_profile' in this.$store.state.user) {
          return !this.$store.state.user.sales_representative_profile.hide_posting_instructions;
        }
        return true;
      }
    },
    methods: {
      generatePath (pathName, item) {
        return `/${pathName}/${item.id}`
      },
      fetchDashboards(search) {
        var self = this;
        API.dashboards.getList({ q: search })
           .then(function(response) {
             self.$set(self, 'dashboardList', response.data.results);
           });

      },
      fetchCustomers() {
        var self = this;
        return API.requests.getCustomers()
	                .then(function (response) {
                    self.customersList = response.data.results;
                  });
      },
    }
 }
</script>

<style lang="scss" scoped>
 @import "./static/css/_variables.scss";

 .app-sidebar {
     display: grid;
     grid-template-areas:
         "menu"
         "footer";
     grid-template-rows: 1fr 2rem;
     position: fixed;
     top: 36px;
     left: 0;
     bottom: 0;
     width: $sidebar-width;
     min-width: 45px;
     max-height: 100vh;
     background-color: #fff;
     box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);
     font-size: 1rem;

     .brand {
         padding: 15px!important;

         .brandname {
             font-weight: 300;
             font-size: 1.3rem;
             color: #002754;
         }
     }

     .menu-list {
         margin: 0;
         padding: 0;
         overflow-x: hidden;
         overflow-y: auto;

         li.sidebar-search-wrapper {
             border: 0;
             display: initial;
             margin-bottom: 10px;
         }

         .sub-menu li.sidebar-search-wrapper .sidebar-search {
             padding: 0 16px 0 0;
         }

         .sub-menu li.sidebar-search-wrapper + li {
             margin-top: 10px !important;
         }

         &> li {
             list-style-type: none;
             display: block;
             margin: 0;
             padding: 0;
             border: none;
             border-bottom: 1px solid #98a8bb;
         }
     }

     footer {
         color: #eee;

         .copyright {
             text-align: center;
             background-color: #555;
             border-top: 1px solid #999;
             line-height: 2rem;
         }
     }
 }

 .app-sidebar .menu-list > li.active > a,
 .app-sidebar .menu-list > li > a:focus,
 .app-sidebar .menu-list > li > a:hover {
     background: #f2f6f9;
 }
.app-sidebar .menu-list li a[aria-expanded="true"] .is-angle {
  transform: rotate(180deg);
}

.app-sidebar .menu-list .sub-menu {
  border-left: 1px solid #dbdbdb;
  margin: 0 0 20px 15px;
  padding-left: 10px;
    max-height: 250px;
    overflow: auto;
}
.app-sidebar .menu-list .sub-menu li {
  list-style-type: none;
  background: 0 0;
  padding: 0;
  margin-top: 1px!important;
}
.app-sidebar .menu-list .sub-menu li > a {
  display: block;
  margin: 0;
  padding: 6px 0px;
  text-decoration: none;
  font-size: 1.05rem;
  font-weight: 300;
  background: 0 0;
}
.app-sidebar .menu-list .sub-menu  > li.active > a,
.app-sidebar .menu-list .sub-menu > li > a:focus,
.app-sidebar .menu-list .sub-menu> li > a:hover {
  color: #002754;
  background: #f2f6f9;
}

.app-sidebar .sidebar-search {
  padding: 0;
  margin: 0 0 20px 10px;
}
.app-sidebar .sidebar-search .input-group {
  border: 1px solid #ced6de;
  border-radius: 0px!important;
}
.app-sidebar .sidebar-search .input-group .form-control {
    text-indent: 0;
    padding: 6px 12px;
    color: #7f96ac;
    border: 0 !important;
    box-shadow: none !important;
    background: 0 0!important;
}

.app-sidebar .icon {
  vertical-align: baseline;
}
.app-sidebar .icon.is-angle {
  transition: transform .377s ease;
}

.menu-list {
  & > li >  a {
    display: block;
    padding: 12px 15px;
    cursor: pointer;
  }

  .sub-menu {
    .menu-item {
      margin-left: -10px;

      a {
        display: block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        &::before {
          content: "─";
          color: #dbdbdb;
          padding-right: 4px;
        }

        &.router-link-active {
          background-color: $ls-background-light-color;
        }
      }

    }
  }
}

.sidebar-buttons {
  width: 100%;
  padding: 10px 0px 10px 10px;

  .btn {
    width: 95%;
    color: $ls-clickable-color;
    border-color: $ls-clickable-color;

    &:hover,
    &:focus {
      border-color: $ls-highlight-color;
      color: $ls-highlight-color;
      background-color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Sidebar.vue?c57c13b0